'use client';

import { MobileDownloadButton } from './MobileDownloadButton';
import { DesktopDownloadSection } from './DesktopDownloadSection';

interface AppDownloadProps {
  // Content
  heading?: string;
  headingLevel?: 'h1' | 'h2';
  subheading?: string;
  mobileButtonText?: string;

  // URLs
  downloadUrl: string;
  qrCodeImage?: string;

  // Accessibility
  mobileButtonAriaLabel?: string;
  appleStoreAriaLabel?: string;
  googlePlayAriaLabel?: string;
}

export const APP_DOWNLOAD_COMPONENT_NAME = 'AppDownload';

export const AppDownload = ({
  // Content
  heading = 'Download the Tempcover app',
  headingLevel = 'h1',
  subheading = 'Get covered in seconds and get 30% off the Tempcover fee',
  mobileButtonText = 'Get the app!',
  // URLs
  downloadUrl,
  qrCodeImage,
  // Accessibility
  mobileButtonAriaLabel,
  appleStoreAriaLabel,
  googlePlayAriaLabel,
}: AppDownloadProps) => {
  const HeadingTag = headingLevel;

  const headingClasses =
    headingLevel === 'h1'
      ? 'text-dark mb-4 text-[43px] leading-[120%] font-black md:text-[50px] lg:text-[55px]'
      : 'text-dark mt-4 mb-4 text-[34px] leading-[120%] font-black text-balance md:text-[40px] lg:text-[44px]';

  return (
    <div className="tc-container py-8">
      {(heading || subheading) && (
        <header className="mb-6 text-left md:text-center">
          {heading && <HeadingTag className={headingClasses}>{heading}</HeadingTag>}
          {subheading && <p className="text-dark text-[18px] leading-[120%] font-bold md:text-[23px]">{subheading}</p>}
        </header>
      )}

      <DesktopDownloadSection
        qrCodeImage={qrCodeImage}
        badgeUrl={downloadUrl}
        appleAriaLabel={appleStoreAriaLabel}
        googleAriaLabel={googlePlayAriaLabel}
      />

      <MobileDownloadButton url={downloadUrl} buttonText={mobileButtonText} ariaLabel={mobileButtonAriaLabel} />
    </div>
  );
};
